import { BaseListModel } from "../base/base-list-model";
import { CompanyModel } from "./company.model";

export const CompaniesListModel = BaseListModel(CompanyModel).named("Companies");
